import { Badge } from "@/components/ui";
import { colorDeAccion } from "../data/acciones-tono";

export function AccionBadge({ accion }: { accion: string }) {
  return (
    <Badge variant="light" color={colorDeAccion(accion)}>
      {accion}
    </Badge>
  );
}
